<template>
  <el-dialog
    v-model="dialogVisible"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    width="560px"
    append-to-body
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="创意集名称" prop="setName">
        <el-input v-model="form.setName" placeholder="请输入创意集名称" />
      </el-form-item>
      <el-form-item label="媒体" prop="mediaId">
        <search-channel-select v-model="form.mediaId" style="width: 100%" />
      </el-form-item>
      <el-form-item label="广告主" prop="advertiser">
        <el-input v-model="form.advertiser" placeholder="请输入广告主（如：美团、拼多多等）" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="请输入备注" />
      </el-form-item>
    </el-form>
    <div style="text-align: right">
      <el-button @click="close" size="medium">取消</el-button>
      <el-button @click="submit" type="primary" size="medium" :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addCreativeSet, updateCreativeSet } from '@/api/manage/creativeSet/creativeSet'
import SearchChannelSelect from '@/components/SearchChannelSelect'

const defaultForm = {
  id: undefined,
  setName: '',
  mediaId: '',
  advertiser: '',
  remark: ''
}

export default {
  components: {
    SearchChannelSelect
  },
  emits: ['submit'],
  data () {
    return {
      dialogVisible: false,
      submitLoading: false,
      form: Object.assign({}, defaultForm),
      rules: {
        setName: [{ required: true, message: '请输入创意集名称', trigger: 'blur' }],
        mediaId: [{ required: true, message: '请选择媒体', trigger: 'change' }],
        advertiser: [{ required: true, message: '请输入广告主', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle () {
      return this.form.id ? '编辑创意集' : '新增创意集'
    }
  },
  methods: {
    show (data) {
      this.dialogVisible = true
      if (data) {
        this.form = Object.assign({}, data)
      }
    },
    close () {
      this.dialogVisible = false
      this.reset()
    },
    reset () {
      this.form = Object.assign({}, defaultForm)
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    submit () {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.submitLoading = true
        const api = this.form.id ? updateCreativeSet : addCreativeSet
        api(this.form).then((res) => {
          if (res.code === 200) {
            this.$message.success(this.form.id ? '编辑成功' : '新增成功')
            this.$emit('submit')
            this.close()
          }
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 18px;
}
</style>
